// Always use current domain — Kubernetes ingress routes /api to backend
export const API = `${window.location.origin}/api`;
